import _get from 'lodash/get';

export const transformCompletedOrders = orders => {
  const ordersCopy = [...orders];
  ordersCopy.sort(
    (a, b) =>
      _get(b, 'createMeta.createAtInTs') - _get(a, 'createMeta.createAtInTs'),
  );

  const withDefaults = [];
  const sourceOptions = [];
  ordersCopy.forEach(order => {
    const source = _get(order, 'source', 0);
    if (sourceOptions.indexOf(source) === -1) sourceOptions.push(source);

    withDefaults.push({ ...order, amount: order.amount || 0, source });
  });

  return { orders: withDefaults, sourceOptions };
};

export default {};
